import { render, staticRenderFns } from "./RELabelFilter.vue?vue&type=template&id=6e22c968"
import script from "./RELabelFilter.vue?vue&type=script&lang=js"
export * from "./RELabelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports